
import { useCallback, useEffect } from 'react';
import { useRouter } from 'next/navigation';



function useConfirmExit(confirmExit: () => boolean, when = true) {

  const router = useRouter();

  useEffect(() => {

    if (!when) {
      return;
    }

    const push = router.push;

    router.push = (...args: Parameters<typeof push>) => {

      const result = confirmExit();
      
      if (result !== false) {
        window.onbeforeunload = null;
        return push(...args);
      }



    };

    return () => {
      router.push = push;
      
    };

  }, [router, confirmExit, when]);

}


export function usePrompt(message: string, when = true) {

  useEffect(() => {

    if (when) {
      window.onbeforeunload = function () {
        return message;
      };
    }

    return () => {
      window.onbeforeunload = null;
    };
  }, [message, when]);

  const confirmExit = useCallback(() => {
    const confirm = window.confirm(message);
    return confirm;
  }, [message]);

  useConfirmExit(confirmExit, when);

}

